import React from "react";
import { ProjectDetails } from "components";

const Project = ({ data }) => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-xs-12">
        <ProjectDetails {...data} />
      </div>
    </div>
  </div>
);

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project.jsx